import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";


// For Login and Change Password Pages UI
export const cPageStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: "flex",
      flexWrap: "wrap",
      width: 450,
      margin: `${theme.spacing(0)} auto`,
    },
    loginBtn: {
      "&:hover": {
        background: "#2675be",
      },
      marginTop: theme.spacing(1),
      flexGrow: 1,
      background: "#3b86cc",
    },
    changePsdBtn: {
      "&:hover": {
        background: "#F2F3F5",
        color: "#1758E8",
      },
      background: "#fff",
      marginTop: theme.spacing(1),
    },
    header: {
      background: "#ffffff",
      color: "#fff",
      size: "100%",
    },
    img: {
      height: "65px",
      width: "350px",
      marginLeft: "50px",
      marginTop: "15px",
    },
    card: {
      marginTop: theme.spacing(10),
    },
    textfield: {
      "&focus-within label": {
        color: "#000",
      },
    },
    input: {
      "&focus": {
        opacity: 0,
      },
    },

    icon: {
      padding: "10px",
      background: "dodgerblue",
      color: "white",
      minWidth: "50px",
      textAlign: "center",
    },
  })
);
